import { configureStore } from "@reduxjs/toolkit";
import dialogSlice from "../components/dialog/dialogSlice";
import loginReducer from "../features/login/loginSlice";
import userSlice from "../features/user/userSlice";
import menuSlice from "../features/menu/menuSlice";
import rightsSlice from "../features/rights/rightsSlice";
import userTypeSlice from "../features/userType/userTypeSlice";
import muiDrawerSlice from "../components/muidrawer/muiDrawerSlice";
import dashboardSlice from "../features/dashboard/dashboardSlice";
import bannerSlice from "../features/banner/bannerSlice";
import cmsSlice from "../features/cms/cmsSlice";
import seotagSlice from "../features/seotag/seotagSlice";
import testimonialSlice from "../features/testimonial/testimonialSlice";
import blogSlice from "../features/blog/blogSlice";
import faqSlice from "../features/faq/faqSlice";
import usefullinksSlice from "../features/usefullinks/usefullinksSlice";
import contactSlice from "../features/contact/contactSlice";
import paginationSlice from "../features/pagination/paginationSlice";
import settingSlice from "../features/setting/settingSlice";
import ticketBookingSlice from "../features/ticketbooking/ticketBookingSlice";

const store = configureStore({
  reducer: {
    login: loginReducer,
    dashboard: dashboardSlice,
    dialog: dialogSlice,
    muidrawer: muiDrawerSlice,
    user: userSlice,
    menu: menuSlice,
    rights: rightsSlice,
    userType: userTypeSlice,
    cms: cmsSlice,
    pagination: paginationSlice,
    seotag: seotagSlice,
    blog: blogSlice,
    testimonial: testimonialSlice,
    banner: bannerSlice,
    faq: faqSlice,
    usefullinks: usefullinksSlice,
    contact: contactSlice,
    setting: settingSlice,
    ticketBooking: ticketBookingSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
